/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Policy_TitleInputs */

const en_mk_team_policy_title = /** @type {(inputs: Mk_Team_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An honest provider policy`)
};

const id_mk_team_policy_title = /** @type {(inputs: Mk_Team_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kebijakan penyedia yang jujur`)
};

/**
* | output |
* | --- |
* | "An honest provider policy" |
*
* @param {Mk_Team_Policy_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_policy_title = /** @type {((inputs?: Mk_Team_Policy_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Policy_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_policy_title(inputs)
	return en_mk_team_policy_title(inputs)
});